
export default {
  props: {
    order: { default: () => ({}), type: Object }
  }
};
